'use strict';

/** Wrapper for Instagram embed.js */

const INSTAGRAM_SCRIPT_ID = 'instagram-wjs';
const INSTAGRAM_EMBED_CODE_SELECTORS = 'blockquote.instagram-media';

function InstagramWidgets(root) {
  // Don't load Instagram script until we're on a page that includes widgets
  if (!root.querySelector(INSTAGRAM_EMBED_CODE_SELECTORS)) {
    return;
  }

  if (document.getElementById(INSTAGRAM_SCRIPT_ID)) {
    window.instgrm.Embeds.process(root);
    return;
  }

  // Dynamically load Instagram embed.js
  const head = document.querySelector('head');
  const js = document.createElement('script');
  js.id = INSTAGRAM_SCRIPT_ID;
  js.async = true;
  js.src = 'https://www.instagram.com/embed.js';
  js.onload = function () {
    window.instgrm.Embeds.process(root);
  };

  head.appendChild(js);
}

// Unlike other UIComponents, Instagram widgets are initialized within the element root,
// so we always return one component that may or may not contain widgets later.
InstagramWidgets.discover = function (root) {
  return {
    components: [new InstagramWidgets(root)],
    errors: []
  };
};

module.exports = InstagramWidgets;
